import { z } from 'zod';
import { dolapBoyutu } from '../nokta/dolap.js';
export const fiyatKurali = z.object({
    id: z.string(),
    noktaId: z.string().nullable().optional(),
    noktaKod: z.string().nullable().optional(),
    noktaAd: z.string().nullable().optional(),
    dolapBoyutu: dolapBoyutu.nullable().optional(),
    oncelik: z.number().int(),
    gunlerMask: z.number().int().min(0).max(127),
    saatBaslangic: z.number().int().min(0).max(24),
    saatBitis: z.number().int().min(0).max(24),
    tarihBaslangic: z.string().datetime().nullable().optional(),
    tarihBitis: z.string().datetime().nullable().optional(),
    carpan: z.string(),
    sabitTutar: z.string().nullable().optional(),
    aciklama: z.string(),
    aktif: z.boolean(),
    olusturmaTarihi: z.string().datetime(),
});
const fiyatKuralAlanlari = z.object({
    noktaId: z.string().nullable().optional(),
    dolapBoyutu: dolapBoyutu.nullable().optional(),
    oncelik: z.number().int().min(0).max(1000).default(100),
    gunlerMask: z.number().int().min(0).max(127).default(127),
    saatBaslangic: z.number().int().min(0).max(24).default(0),
    saatBitis: z.number().int().min(0).max(24).default(24),
    tarihBaslangic: z.string().datetime().nullable().optional(),
    tarihBitis: z.string().datetime().nullable().optional(),
    carpan: z
        .string()
        .regex(/^\d+(\.\d{1,3})?$/, 'Geçerli çarpan girin')
        .default('1.000'),
    sabitTutar: z
        .string()
        .regex(/^\d+(\.\d{1,2})?$/, 'Geçerli tutar girin')
        .nullable()
        .optional(),
    aciklama: z.string().trim().min(3).max(200),
    aktif: z.boolean().default(true),
});
export const fiyatKuralOlusturIstegi = fiyatKuralAlanlari.refine((d) => d.saatBitis > d.saatBaslangic, { message: 'Bitiş saati başlangıçtan büyük olmalı', path: ['saatBitis'] });
export const fiyatKuralGuncelleIstegi = fiyatKuralAlanlari.partial();
export const fiyatKuralSorgusu = z.object({
    sayfa: z.coerce.number().int().min(1).default(1),
    boyut: z.coerce.number().int().min(1).max(100).default(50),
    noktaId: z.string().optional(),
    aktif: z.coerce.boolean().optional(),
});
//# sourceMappingURL=fiyat-kurali.js.map